// src/pages/AdminOrders.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    axios.get('https://shophub-server.vercel.app/api/orders')
      .then(res => setOrders(res.data))
      .catch(console.error);
  }, []);

  const updateStatus = (id, status) => {
    axios.put(`https://shophub-server.vercel.app/api/orders/${id}/status`, { status })
      .then(res => {
        setOrders(orders.map(o => o._id === id ? res.data : o));
      })
      .catch(console.error);
  };

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">📦 Admin Orders</h1>
      <div className="grid md:grid-cols-2 gap-4">
        {orders.map(order => (
          <div key={order._id} className="bg-white border rounded-lg p-4 shadow space-y-2">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-bold">#{order._id.slice(-6)}</h2>
              <span className="text-sm text-gray-500">{new Date(order.createdAt).toLocaleString()}</span>
            </div>
            <p><strong>Customer:</strong> {order.customer.name}</p>
            <p><strong>Status:</strong> <span className="capitalize">{order.status}</span></p>
            <p><strong>Total:</strong> ${(order.totalAmount / 100).toFixed(2)}</p>

            <div className="flex gap-2 mt-2">
              {order.status === 'pending' && (
                <button onClick={() => updateStatus(order._id, 'paid')}
                  className="bg-yellow-500 text-white px-3 py-1 rounded">Force Paid</button>
              )}
              {order.status === 'paid' && (
                <button onClick={() => updateStatus(order._id, 'shipped')}
                  className="bg-blue-500 text-white px-3 py-1 rounded">Mark Shipped</button>
              )}
              {order.status === 'shipped' && (
                <button onClick={() => updateStatus(order._id, 'sent')}
                  className="bg-green-500 text-white px-3 py-1 rounded">Mark Delivered</button>
              )}
              <Link to={`/admin/orders/${order._id}`}
                className="ml-auto text-blue-600 underline text-sm">View Details</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
